export const API_BASE_URL = "https://bullenffapi.azure-api.net/api";
export const LEAGUE_ID = 626545;
export const LEAGUE_NAME = "The Bullen";
